import React from 'react';

const FinanceKPICards = ({ budgetMargin, actualMargin, budgetVariance, cashflow, grossMargin, netMargin }) => {
  const fmt = (val) => {
    if (val == null || val === '') return '$0.00';
    const n = parseFloat(val);
    if (isNaN(n)) return '$0.00';
    const prefix = n < 0 ? '-$' : '$';
    return prefix + Math.abs(n).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  };

  const marginClass = (val) => {
    const n = parseFloat(val || 0);
    if (n > 0) return 'fc-kpi-positive';
    if (n < 0) return 'fc-kpi-negative';
    return '';
  };

  return (
    <div className="fc-kpi-container">
      <div className="fc-kpi-card">
        <span className="fc-kpi-label">Gross Margin</span>
        <span className={`fc-kpi-value ${marginClass(grossMargin)}`}>{fmt(grossMargin)}</span>
      </div>
      <div className="fc-kpi-card">
        <span className="fc-kpi-label">Net Margin</span>
        <span className={`fc-kpi-value ${marginClass(netMargin)}`}>{fmt(netMargin)}</span>
      </div>
      <div className="fc-kpi-card">
        <span className="fc-kpi-label">Budget Margin</span>
        <span className="fc-kpi-value">{fmt(budgetMargin)}</span>
      </div>
      <div className="fc-kpi-card">
        <span className="fc-kpi-label">Budget Variance</span>
        <span className={`fc-kpi-value ${parseFloat(budgetVariance || 0) < 0 ? 'fc-negative' : ''}`}>
          {fmt(budgetVariance)}
        </span>
      </div>
      <div className="fc-kpi-card">
        <span className="fc-kpi-label">Actual Margin</span>
        <span className="fc-kpi-value">{fmt(actualMargin)}</span>
      </div>
      <div className="fc-kpi-card">
        <span className="fc-kpi-label">Cashflow</span>
        <span className="fc-kpi-value">{fmt(cashflow)}</span>
      </div>
    </div>
  );
};

export default FinanceKPICards;
